import { heroData } from '@/mocks/homeData';

export default function Hero() {
  return (
    <section
      id="hero"
      className="relative w-full min-h-screen flex items-center overflow-hidden bg-background-50"
    >
      <div className="absolute inset-0 z-0">
        <img
          src="https://readdy.ai/api/search-image?query=Warm%20atmospheric%20abstract%20background%20with%20soft%20gradients%20of%20coral%20and%20warm%20amber%20tones%2C%20gentle%20flowing%20curves%20reminiscent%20of%20comic%20book%20motion%20lines%2C%20artistic%20illustration%20style%20with%20textured%20brush%20strokes%2C%20minimalist%20composition%20with%20ample%20negative%20space%2C%20warm%20and%20inviting%20atmosphere%2C%20soft%20organic%20shapes%20with%20subtle%20line%20art%20elements%2C%20light%20cream%20and%20peach%20color%20palette&width=1920&height=1080&seq=hero-bg-manga-01&orientation=landscape"
          alt="羞羞漫画背景"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-br from-background-50/70 via-background-50/40 to-primary-100/30"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 py-24 md:py-0">
        <div className="max-w-7xl mx-auto flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="flex flex-wrap items-center gap-2 justify-center lg:justify-start mb-4">
              {heroData.tags.map((tag) => (
                <span
                  key={tag}
                  className="px-3 py-1 text-xs font-medium bg-primary-100/80 text-primary-700 rounded-full whitespace-nowrap"
                >
                  {tag}
                </span>
              ))}
            </div>

            <h1 className="font-heading text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-foreground-950 leading-tight">
              羞羞漫画
              <span className="block text-primary-600 text-2xl sm:text-3xl md:text-4xl lg:text-5xl mt-2">
                韩漫日漫国漫免费在线阅读平台
              </span>
            </h1>

            <p className="mt-4 text-lg md:text-xl text-foreground-600 font-medium">
              {heroData.slogan}
            </p>

            <p className="mt-6 text-sm md:text-base text-foreground-600 leading-relaxed max-w-xl mx-auto lg:mx-0">
              {heroData.description}
            </p>

            <div className="mt-8 flex flex-wrap items-center gap-6 justify-center lg:justify-start">
              {heroData.stats.map((stat, idx) => (
                <div key={idx} className="flex items-center gap-2">
                  <span className="text-2xl md:text-3xl font-bold text-primary-600 font-heading">
                    {stat.value}
                  </span>
                  <span className="text-xs md:text-sm text-foreground-500">
                    {stat.label}
                  </span>
                  {idx < heroData.stats.length - 1 && (
                    <span className="hidden sm:block w-px h-6 bg-background-300 ml-4"></span>
                  )}
                </div>
              ))}
            </div>

            <div className="mt-8 flex flex-col sm:flex-row items-center gap-3 justify-center lg:justify-start">
              <a
                href={heroData.primaryCta.href}
                className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-8 py-3.5 text-base font-medium bg-primary-500 text-background-50 rounded-full hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-book-open-line"></i>
                {heroData.primaryCta.label}
              </a>
              <a
                href={heroData.secondaryCta.href}
                className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-8 py-3.5 text-base font-medium border border-background-300 text-foreground-700 rounded-full hover:border-primary-300 hover:text-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-fire-line"></i>
                {heroData.secondaryCta.label}
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-lg lg:max-w-none">
            <div className="relative w-full aspect-[4/5] lg:aspect-[5/6] rounded-2xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Elegant%20manga%20reading%20scene%20with%20a%20stylishly%20illustrated%20comic%20book%20open%20displaying%20beautiful%20artwork%2C%20surrounded%20by%20soft%20warm%20ambient%20lighting%2C%20minimalist%20aesthetic%20with%20artistic%20brush%20strokes%20and%20gentle%20gradients%2C%20warm%20coral%20and%20cream%20tones%2C%20editorial%20product%20photography%20style%20with%20clean%20composition%20and%20soft%20shadows%2C%20elevated%20mood%20with%20asian%20illustration%20art%20elements&width=800&height=1000&seq=hero-visual-manga&orientation=portrait"
                alt="羞羞漫画 - 免费韩漫日漫国漫在线阅读"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-background-50/20 to-transparent rounded-2xl"></div>
            </div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10 hidden md:block">
        <a
          href="#updates"
          className="flex flex-col items-center gap-1 text-foreground-400 hover:text-primary-500 transition-colors cursor-pointer"
        >
          <span className="text-xs">向下滚动</span>
          <i className="ri-arrow-down-s-line text-lg animate-bounce"></i>
        </a>
      </div>
    </section>
  );
}